import { memo } from "react";
import PropTypes from "prop-types";
import { brandPropTypes, resolutionPropType } from "app/utils/propTypes";
import SimpleProgressiveImg from "app/pages/.shared/SimpleProgressiveImg";
import { BRANDS } from "app/constants";
import List from "app/pages/.shared/List";
import { FormattedMessage } from "react-intl";
import "./CreditCardMarketingBanner.scss";
import FloatingButton from "app/pages/.shared/Popover/FloatingButton";

const IMG_SIZES = {
	small: { width: 710, height: 120 },
	medium: { width: 710, height: 120 },
	large: { width: 710, height: 120 },
	xlarge: { width: 710, height: 120 },
};

const CreditCardMarketingBanner = ({ brand, shop, resolution }) => {
	return (
		brand === BRANDS.AX &&
		shop === "en-GB" && (
			<FloatingButton
				popoverClassName="credit-card-marketing-banner__button"
				position="top"
				floatingContent={
					<div className="credit-card-marketing-banner__tooltip">
						<List
							items={[
								<FormattedMessage
									id="payment.credit.card.amex.tooltip.message.1"
									key="payment.credit.card.amex.tooltip.message.1"
								/>,
							]}
						/>
					</div>
				}
				referenceComponent={
					<SimpleProgressiveImg
						resolution={resolution}
						sizes={IMG_SIZES}
						src={`https://res.cloudinary.com/perfectstay/image/upload/credit-card-marketing/${brand}/${shop}/banner.png`}
					/>
				}
			/>
		)
	);
};

CreditCardMarketingBanner.propTypes = {
	brand: brandPropTypes,
	shop: PropTypes.string,
	resolution: resolutionPropType,
};

export default memo(CreditCardMarketingBanner);
